import { render } from "./WorkstreamMembers.vue?vue&type=template&id=cb19f6ea&scoped=true"
import script from "./WorkstreamMembers.vue?vue&type=script&lang=js"
export * from "./WorkstreamMembers.vue?vue&type=script&lang=js"

import "./WorkstreamMembers.vue?vue&type=style&index=0&id=cb19f6ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb19f6ea"]])

export default __exports__